export const _exe_name = 'exe_name'
export const error = 'error'
export const Mac = 'Mac'
export const Windows = 'Windows'
export const keydown = 'keydown'
export const bypassType = 'Bypass'
export const blockType = 'Block'
export const ignoreType = 'Do Not Bypass'
export const application = 'application'
export const domain = 'domain'

export const applicationTypeArr = [bypassType, blockType]
export const applicationDefaultTypeArr = [bypassType, ignoreType]

export const ApplicationDefaultBypassList = 'applicationDefaultBypassList'
export const ApplicationIgnoreBypassList = 'applicationIgnoreBypassList'

export const DomainDefaultBypassList = 'domainDefaultBypassList'
export const DomainIgnoreBypassList = 'domainIgnoreBypassList'

export const deletedData = {name: '', type: ''}

export const MAX_BULK_ITEMS = 200
export const BYPASS_INPUT_MAX_LENGTH = 10000

export const DEFAULT_URL_BYPASS_COLUMNS = [
  {
    name: 'DOMAIN NAME',
    dataKey: 'domainName',
    widthPercentage: 60,
  },
  {
    name: 'TRAFFIC',
    dataKey: 'traffic',
    widthPercentage: 35,
  },
  {name: '', dataKey: 'rightArrow', widthPercentage: 5},
]

export const CUSTOM_URL_BYPASS_COLUMNS = [
  {
    name: 'DOMAIN NAME',
    dataKey: 'domainName',
    widthPercentage: 29,
    isSticky: true,
  },
  {name: 'Note', dataKey: 'note', widthPercentage: 30},
  {name: 'Updated By', dataKey: 'updatedBy', widthPercentage: 16},
  {
    name: 'Updated At',
    dataKey: 'updatedAt',
    widthPercentage: 15,
    isFixedWidth: true,
  },
  {
    name: '',
    dataKey: 'right-arrow',
    widthPercentage: 10,
    isFixedWidth: true,
    isPinnedOnMobile: true,
  },
]

export const DEFAULT_APP_BYPASS_COLUMNS = [
  {
    name: 'PROCESS EXECUTABLE NAME',
    dataKey: 'processExecutableName',
    widthPercentage: 40,
  },
  {
    name: 'OS',
    dataKey: 'os',
    widthPercentage: 20,
  },
  {name: 'Traffic', dataKey: 'traffic', widthPercentage: 35},
  {name: '', dataKey: 'rightArrow', widthPercentage: 5},
]

export const CUSTOM_APP_BYPASS_COLUMNS = [
  {
    name: 'PROCESS EXECUTABLE NAME',
    dataKey: 'processExecutableName',
    widthPercentage: 29,
    isSticky: true,
  },
  {name: 'Note', dataKey: 'notes', widthPercentage: 30},
  {
    name: 'OS',
    dataKey: 'os',
    widthPercentage: 9,
  },
  {name: 'Updated By', dataKey: 'updatedBy', widthPercentage: 12},
  {
    name: 'Updated At',
    dataKey: 'updatedAt',
    widthPercentage: 11,
    isFixedWidth: true,
  },
  {
    name: '',
    dataKey: 'rightArrow',
    widthPercentage: 9,
    isFixedWidth: true,
    isPinnedOnMobile: true,
  },
]

// Shared constants for both bypass types
export const FIXED_COLUMN_WIDTHS: Record<string, number> = {
  'empty-column-left': 16,
  'empty-column-right': 16,
}

export const COMMON_TD_ELEMENT_CLASSES = 'pr-4 py-1 overflow-x-hidden'

// Phones scroll the custom tables sideways; the row actions stay pinned to the
// right edge, the way the name column stays pinned to the left.
export const MOBILE_PINNED_ACTIONS_CLASSES =
  'mobile:sticky mobile:right-0 mobile:z-3 mobile:bg-inherit'
